/**
 * Use this query param to control whether the #/account route should attempt to
 * re-establish the latest route the user has visited.
 *
 * E.g. we redirect to `#/account?shouldAttemptToReestablishLastVisitedRoute=true
 * after logging in to trigger this.
 *
 * Hint: See 'useRedirectToStartingPoint' in 'app/react/routes/account/account.tsx'
 * to see how the latest route is re-established.
 */
export const SHOULD_ATTEMPT_TO_REESTABLISH_LAST_VISITED_ROUTE_QUERY_PARAM =
    'shouldAttemptToReestablishLastVisitedRoute';

export const ACCOUNT_SUBROUTE_CONTENT_ID = 'accountSubrouteContentId';
export const PAY_NOW_MODAL_TOOLBOX = 'payNowModalToolbox';
export const JUST_SIGNED_UP_PARAM = 'justSignedUp';
export const LOGIN_VALIDATION_CARD_WIDTH = 453;
export const WEBSITE_SIGNUP_PARAM = 'websiteSignup';
